import { Headers } from 'cross-fetch'
import { checkStatus, parseJSON, sanitizeUri } from './utils'

class HttpClient {
  /**
   *
   * @param {fetch} fetchApi
   * @param {String} baseUrl
   * @param {String} channel
   * @param {String} clientId
   */
  constructor (fetchApi, baseUrl, channel, clientId = null) {
    this._baseUrl = baseUrl
    this._channel = channel
    this._fetch = fetchApi
    this._clientId = clientId
  }

  /**
   * @returns {Headers}
   */
  get headers () {
    return {
      canal: this._channel,
      clientId: this.clientId,
      channel: this.channel,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Methods': 'GET, POST, PUT',
      'Access-Control-Allow-Origin': '*'
    }
  }

  /**
   * @param {string} clientId
   * @returns {HttpClient}
   */
  setClientId (clientId) {
    this.clientId = clientId
    return this
  }

  /**
   * @param {string} channel
   * @returns {HttpClient}
   */
  setChannel (channel) {
    this.channel = channel
    return this
  }

  requestRaw (path, options = {}, customHeaders = {}) {
    const uri = sanitizeUri(`${this._baseUrl}/${path}`)
    return this._fetch(uri, {
      headers: new Headers({ ...this.headers, ...customHeaders }),
      ...options
    })
  }

  /**
   * make an http request
   * @param {String} path
   * @param {Object} options
   *
   * @returns {Promise<Object>}
   */
  request (path, options = {}, isJson = true, customHeaders = {}) {
    return this.requestRaw(path, options, customHeaders)
      .then(checkStatus)
      .then(response => {
        return isJson
          ? parseJSON(response)
          : response.text()
      })
  }

  /**
   * make a GET request
   * @param {String} path
   *
   * @returns {Promise<Object>}
   */
  get (path) {
    return this.request(path, {
      method: 'GET'
    })
  }

  /**
   * make a POST request
   * @param {String} path
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  post (path, data, isJson = true, customHeaders = {}) {
    return this.request(path, {
      method: 'POST',
      body: data ? JSON.stringify(data) : null
    }, isJson, customHeaders)
  }
}

export { HttpClient }
